import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { cardBackground } from '@features/executive-report/slides/v2/components/card-background';
import { Slide } from '@features/powerpoint';
import { formatters, ValueInput } from '@utils/formattersV2';

const CARD_HEIGHT = 1.28;
const CARD_WIDTH = 4;
const CARD_X = 8.88;
const CARD_Y_START = 3.07;
const CARD_Y_OFFSET = CARD_HEIGHT + 0.13;

type KeyDriversProps = {
  avgPricePerTransaction: ValueInput;
  avgTotalBasketAmount: ValueInput;
  avgPurchaseFrequency: ValueInput;
};

export const buildKeyDriversCards = (
  props: KeyDriversProps
): Required<Pick<Slide, 'shapes' | 'texts'>> => {
  return {
    shapes: [
      cardBackground({
        h: CARD_HEIGHT,
        w: CARD_WIDTH,
        x: CARD_X,
        y: CARD_Y_START,
      }),
      cardBackground({
        h: CARD_HEIGHT,
        w: CARD_WIDTH,
        x: CARD_X,
        y: CARD_Y_START + CARD_Y_OFFSET,
      }),
      {
        shapeName: 'line',
        options: {
          line: { width: 1, color: themeV2.colors.inmarketGreen },
          h: 0,
          w: 1.68,
          x: 11.06,
          y: 3.36,
        },
      },
      {
        shapeName: 'line',
        options: {
          line: { width: 1, color: themeV2.colors.inmarketGreen },
          h: 0,
          w: 2.23,
          x: 10.37,
          y: 4.89,
        },
      },
    ],
    texts: [
      {
        text: [
          {
            text: 'MORE ',
          },
          {
            text: 'PURCHASES',
            options: { color: themeV2.colors.inmarketGreen },
          },
        ],
        options: {
          fontSize: 12,
          bold: true,
          valign: 'middle',
          h: 0.3,
          w: 1.88,
          x: 8.94,
          y: 3.12,
        },
      },
      {
        text: 'This is the average transaction size in dollars for your brand and the total retailer basket size when your brand was purchased.',
        options: {
          fontSize: 8,
          valign: 'middle',
          h: 0.77,
          w: 1.75,
          x: 8.93,
          y: 3.42,
        },
      },
      {
        text: 'TRANSACTION SIZE',
        options: {
          fontSize: 10,
          bold: true,
          align: 'center',
          valign: 'middle',
          h: 0.22,
          w: 2.03,
          x: 10.88,
          y: 3.14,
        },
      },
      {
        text: 'AVG. PRICE PER TRANSACTION',
        options: {
          fontSize: 7,
          color: themeV2.colors.inmarketGreen,
          bold: true,
          align: 'center',
          valign: 'middle',
          h: 0.22,
          w: 1.08,
          x: 10.69,
          y: 3.55,
        },
      },
      {
        text: formatters.currency(props.avgPricePerTransaction, {
          decimals: 2,
        }),
        options: {
          fontSize: 18,
          align: 'center',
          valign: 'middle',
          h: 0.4,
          w: 1.26,
          x: 10.6,
          y: 3.82,
        },
      },
      {
        text: 'AVG. TOTAL BASKET AMOUNT',
        options: {
          fontSize: 7,
          color: themeV2.colors.inmarketGreen,
          bold: true,
          align: 'center',
          valign: 'middle',
          h: 0.22,
          w: 1.18,
          x: 11.69,
          y: 3.55,
        },
      },
      {
        text: formatters.currency(props.avgTotalBasketAmount, { decimals: 2 }),
        options: {
          fontSize: 18,
          align: 'center',
          valign: 'middle',
          h: 0.4,
          w: 1.26,
          x: 11.65,
          y: 3.82,
        },
      },
      {
        text: 'This is the count of times that average exposed consumer purchased your brand during the campaign timeframe.',
        options: {
          fontSize: 8,
          valign: 'middle',
          h: 1.28,
          w: 1.38,
          x: 9,
          y: 4.48,
        },
      },
      {
        text: 'AVG. PURCHASE FREQUENCY',
        options: {
          fontSize: 10,
          bold: true,
          align: 'center',
          valign: 'middle',
          h: 0.27,
          w: 2.38,
          x: 10.3,
          y: 4.62,
        },
      },
      {
        text: `${formatters.number(props.avgPurchaseFrequency, { decimals: 2 })}x`,
        options: {
          fontSize: 18,
          align: 'center',
          valign: 'middle',
          h: 0.4,
          w: 1.26,
          x: 10.86,
          y: 5.09,
        },
      },
    ],
  };
};
